import React from "react"

import NotificationContainer from "components/NotificationContainer"

import TranscriptDownload from "./TranscriptDownload"
import TranscriptViewer from "./TranscriptViewer"

type TranscriptOptionsProps = {
  sessionId: string
}

const TranscriptOptions: React.FC<TranscriptOptionsProps> = ({ sessionId }) => {
  return (
    <>
      <NotificationContainer />
      <div className="flex gap-2">
        <TranscriptViewer sessionId={sessionId} />
        <TranscriptDownload sessionId={sessionId} />
      </div>
    </>
  )
}

export default TranscriptOptions
